import styled from 'styled-components/macro';
import { Input, InputStyled as InputStyledDefault, InputWrapper } from '@yme/atoms/input';
import { colorWhiteTransparent300 } from '@yme/tokens/colors';
import { ADAPTIVE } from '@yme/tokens/screen';
export const InputStyled = styled(Input) `
  width: 100%;

  ${InputWrapper} {
    &:focus-visible {
      input {
        outline: -webkit-focus-ring-color auto 1px;
      }
    }
  }

  ${InputStyledDefault} {
    background: ${({ backgroundColor }) => backgroundColor || colorWhiteTransparent300};
  }

  ${ADAPTIVE.minWidth.desktop} {
    ${({ hasFilters }) => !hasFilters && 'flex-basis: 50%;'}
  }

  & input {
    ${({ isRightToLeft }) => (!isRightToLeft ? 'padding-right: 40px;' : 'padding-left: 40px;')}
  }
`;
